import content_exchange_list from './exchange-list';
import content_exchange_add from './exchange-add';
import content_exchange_edit from './exchange-edit';
import content_exchange_detail from './exchange-detail';

export default {
    content_exchange_list,
    content_exchange_add,
    content_exchange_edit,
    content_exchange_detail,
};
